import { LocalStorageAcceptableKeys, Nullable } from '../types';

const useTypedLocalStorage = <T extends object>(
  key: LocalStorageAcceptableKeys,
) => {
  const getObject = (): Nullable<T> =>
    localStorage.getObject<T, LocalStorageAcceptableKeys>(key);

  const setObject = (value: T) =>
    localStorage.setObject<T, LocalStorageAcceptableKeys>(key, value);

  const updateObjectProperty = (property: keyof T, value: T[keyof T]) =>
    localStorage.updateObjectProperty(key, property, value);

  const updateObjectPropertyKey = (
    propertyKey: keyof T,
    innerPropertyKey: string,
    innerPropetyValue: any,
  ) =>
    localStorage.updateObjectPropertyKey(
      key,
      propertyKey,
      innerPropertyKey,
      innerPropetyValue,
    );

  return {
    getObject,
    setObject,
    updateObjectProperty,
    updateObjectPropertyKey,
  };
};

export default useTypedLocalStorage;
